import { Segment, Divider, Input, Button } from 'semantic-ui-react';
import React from 'react';
import { connect } from 'react-redux';
import { UserActions } from '../../actions';
import { datePicker } from './';

let driver = {
    name: '',
    surname: '',
    licencedate: '',
    licencetype: '',
    licenceplace: '',
    licenceno: '',
};
class CreateDriver extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            driver,
            submitted: false,
            errsoyad: false,
            errad: false,
            erreTarihi: false,
            erreTipi: false,
            erreYeri: false,
            erreNo: false,
            year: '',
            month: '',
            day: '',
        };
        
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.recreate = this.recreate.bind(this);
    }
    onSubmit(){
        var error =false;

        if (this.state.driver.name === ''){
            this.setState({
                errad: true
            });
            error = true;
        }
        if (this.state.driver.surname === '') {
            this.setState({
                errsoyad: true
            });
            error = true;
        }
        
        if (this.state.driver.licencetype === '') {
            this.setState({
                erreTipi: true
            });
        } 
        if (this.state.driver.licenceplace === '') {
            this.setState({
                erreYeri: true
            });
            error = true;
        }
        if (this.state.driver.licenceno === '') {
            this.setState({
                erreNo: true
            });
            error = true;
        }
        
        if (!error){
            let date = this.state.year+ '-'+this.state.month +'-'+this.state.day;
            let dateTime = new Date(date).getTime();
            let timestamp = Math.floor(dateTime / 1000);
            this.state.driver.licencedate = timestamp;

            this.setState({
                submitted: true      
            });
        
            const { dispatch } = this.props;
            dispatch(UserActions.create_driver(this.state.driver));
             
        }
        
        else{
            this.setState({
                error: true
            });
        }
    }
    recreate() {
        window.location.reload();
    }

    handleChange(event) {
        driver[event.target.id] = event.target.value;

        this.setState({
            driver,
            ['err'+event.target.id]: false
        });


    }
    changeDate(event,data){
        this.setState({
            [data.id]: data.value,
        });
    }
    render() {
        if(this.props.driverError !=='' )
            this.state.submitted= false;
        return (
            <div className = {this.props.driverCreating ? 'App-overlay': ''}>
                <Segment id='Egitimler' style={{ height: '50%' }}>
                    <div className='panel-pages-top'>
                        {this.props.driverCreating &&
                    <div className="ui visible loader" />
                        }
                        <h1 id='Egitimler'>Surucu Olustur</h1>
                    </div>
                    <Divider /> 
                    <Segment id='Egitimler-ic'>
                        {!this.state.submitted &&
                     <div className ='Egitimler-div'>
                         <table id= 'create-driver' style={{ width: '100%' }}>
                             <tbody>
                                 <tr>
                                     <td style={{width: '20%'}}>
                                         <span id='items'>Adi Soyadi:</span>
                                     </td>
                                     <td>
                                         <Input type="text" error={this.state.errad} placeholder="Adi*" id='name' onChange={this.handleChange} />
                                     </td>
                                     <td>
                                         <Input type="text" error={this.state.errsoyad} placeholder="Soyadi*" id='surname' onChange={this.handleChange} />
                                     </td>
                                 </tr>
                                 <tr>
                                     <td style={{width: '20%'}}>
                                         <span id='items'>Ehliyet Tarihi ve Yeri:</span>
                                     </td>
                                     {/* <Input type="text" error={this.state.erreTarihi} placeholder="gg/aa/yyyy*" id='licencedate' onChange={this.handleChange} />  */}
                                     {datePicker.bind(this)()}
                                     <td>
                                         <Input type="text" error={this.state.erreYeri} placeholder="Ehliyet Yeri*" id='licenceplace' onChange={this.handleChange} />
                                     </td>
                                 </tr>
                                 <tr>
                                     <td style={{width: '20%'}}>
                                         <span id='items'>Ehliyet Tipi ve No:</span>
                                     </td>
                                     <td>
                                         <Input type="text" error={this.state.erreTipi} placeholder="Ehliyet Tipi*" id='licencetype' onChange={this.handleChange} />
                                     </td>
                                     <td> 
                                         <Input type="text" error={this.state.erreNo} placeholder="Ehliyet No*" id='licenceno' onChange={this.handleChange} />
                                     </td>
                                 </tr>
                          
                                 <tr></tr>
                                 {this.state.error &&
                                <div style={{color: 'red'}}>Tum alanlari doldurun</div>
                                 }
                                 {this.props.driverError!='' &&
                                <div style={{color: 'red'}}>{this.props.driverError}</div>
                                 }
                             </tbody>
                         </table>
                         <br />
                         <Button onClick={this.onSubmit} id='Egitimler'>Gonder</Button> 
                     </div>
                        } 
                        {this.state.submitted && this.props.driverCreated &&
                    <div>
                        <div>Surucu Olusturuldu</div>
                        <br/>
                        <br/>
                        <div>
                            <Button onClick={this.recreate} id='Egitimler'>Tekrar Olustur</Button> 
                        </div>
                    </div>
                        }
                    </Segment>
                </Segment>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {driverCreating, driverError, driverCreated} = state.createDReducer;

    return {
        driverCreating,
        driverError,
        driverCreated,
    };
}
const connectedCreate = connect(mapStateToProps)(CreateDriver);
export { connectedCreate as CreateDriver }; 


// WEBPACK FOOTER //
// ./src/components/PanelPages/CreateDriver.jsx